'use client';
import { SelectInput } from '@curology/ui-components-web/react/SelectInput';
import React from 'react';

import { type Brand } from '@/consts/brands';
import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { useTrackFieldEvent } from '@/utils/metrics';

import { FORM_CONFIG } from '../config';
import {
  type StateOption,
  getStateOptions,
  updateEligibilityData,
} from '../utils/helpers';

export const StateInput = ({
  birthdate,
  setState,
  state,
  brand,
  treatmentCategory,
}: {
  birthdate?: string;
  setState: (value: string) => void;
  state: string;
  brand: Brand;
  treatmentCategory?: TreatmentCategory;
}) => {
  // TODO: Remove hook once Feature Flag package has global tracking helper
  const { trackFieldEntered, trackFieldFocused } = useTrackFieldEvent();

  const stateOptions = getStateOptions();

  return (
    <div>
      <SelectInput
        name="state"
        className="cur-p-2"
        id={FORM_CONFIG.state.name}
        label={FORM_CONFIG.state.label}
        onChange={(event) => {
          const value = event.target.value;

          setState(value);
          trackFieldEntered(FORM_CONFIG.state.name, 1, value);

          updateEligibilityData(brand, {
            birthdate,
            state: value,
            treatmentCategories: treatmentCategory,
          });
        }}
        onFocus={() => trackFieldFocused(FORM_CONFIG.state.name, 1)}
        value={state}
      >
        {stateOptions.map((stateOption: StateOption) => {
          return (
            <option
              disabled={stateOption.disabled}
              key={stateOption.label}
              value={stateOption.value}
            >
              {stateOption.label}
            </option>
          );
        })}
      </SelectInput>
    </div>
  );
};

export default StateInput;
